// removed by extract-text-webpack-plugin
module.exports = {"item":"_2H4nNCyv__44F5thOVwqna","active":"_2qQe1T5JQvxypyVSEqifu3","collaborators-item":"_2TAwnNcEXqQN6Mqlm3UpCB","collaboratorsItem":"_2TAwnNcEXqQN6Mqlm3UpCB","active-collaborators":"_1e8gQVQ_tZyFO11dhJjRtm","activeCollaborators":"_1e8gQVQ_tZyFO11dhJjRtm"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/NavigationBar/components/MenuItem/styles.scss
// module id = 611
// module chunks = 11